import { render, staticRenderFns } from "./SeriesS.vue?vue&type=template&id=0533c4e0&scoped=true"
import script from "./SeriesS.vue?vue&type=script&lang=js"
export * from "./SeriesS.vue?vue&type=script&lang=js"
import style0 from "./SeriesS.vue?vue&type=style&index=0&id=0533c4e0&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0533c4e0",
  null
  
)

export default component.exports